import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/Works/Worlds/prologram/HP_Prologram_1.png'
import _imports_1 from '@/assets/Works/Worlds/prologram/HP_Prologram_2.png'


import TitleCard from '@/components/utils/TitleCard.vue';
import BaseArticle from '@/components/Works/baseArticle.vue';
import DefaultCarousel from '@/components/Works/defaultCarousel.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PrologramView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_q_video = _resolveComponent("q-video")!
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!

  return (_openBlock(), _createBlock(BaseArticle, {
    "product-name": "prologram++",
    imgsrc: require('@/assets/Home/prologram.png'),
    "download-link": "https://drive.google.com/uc?id=1af7lR06kG7eW1WpDktaBGt71GvWx1CA9"
  }, {
    default: _withCtx(() => [
      _createVNode(TitleCard, {
        title: "プログラムを構築してパズルを解け！",
        abst: [
        'ここはドローンが飛び回る未来世界。',
        '君はドローン操縦士になるため、この試験飛行場へやってきた。',
        'さぁ、君の手でプログラムを構築し、難解なステージに挑め！'
      ]
      }),
      _createVNode(TitleCard, { title: "紹介映像" }, {
        abst: _withCtx(() => [
          _createVNode(_component_q_video, {
            src: "https://www.youtube.com/embed/T-l7o9YdEq0",
            class: "innerAssets"
          })
        ]),
        _: 1
      }),
      _createVNode(TitleCard, {
        title: "プログラミング",
        abst: [
        'プログラムの基本は、動作と数値。',
        '動作ブロックと数値ブロックをセットで使うことでドローンを操作できる。',
        '幾つかのルールがあるのでお忘れなく。',
      ]
      }, {
        abst: _withCtx(() => [
          _createVNode(DefaultCarousel, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_carousel_slide, {
                name: 1,
                "img-src": _imports_0
              }),
              _createVNode(_component_q_carousel_slide, {
                name: 2,
                "img-src": _imports_1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(TitleCard, {
        title: "ダウンロード",
        abst: [
        '右下の丸いアイコンから、規約に同意することでダウンロードできます。',
        'Minecraft 1.15.2 / 1.16 / 1.16.1 シングルプレイ/マルチプレイ対応'  
      ]
      }, null, 8, ["abst"])
    ]),
    _: 1
  }, 8, ["imgsrc"]))
}
}

})